import { NgModule } from "@angular/core";
import {
	MatIconModule,
	// MatSnackBarConfig,
	MatTooltipModule,
	MatSelectModule,
	MatProgressBarModule,
	MatCardModule,
	MatButtonModule,
	MatExpansionModule,
	MatInputModule,
	MatDialogModule,
	MatMenuModule,
	MatSidenavModule,
	MatListModule,
	MatSlideToggleModule,
	MatRadioModule,
	MatStepperModule,
	MatGridListModule,
	MatProgressSpinnerModule,
	MatToolbarModule
} from "@angular/material";

import { AutoCompleteModule } from "primeng/autocomplete";
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from "primeng/checkbox";
import { MultiSelectModule } from "primeng/multiselect";
import { RadioButtonModule } from "primeng/radiobutton";
import { TableModule } from "primeng/table";
import { CalendarModule } from "primeng/calendar";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { DropdownModule } from "primeng/dropdown";
import { SliderModule } from "primeng/slider";
import { ListboxModule } from "primeng/listbox";

@NgModule({
	imports: [
		MatIconModule,
		MatTooltipModule,
		MatSelectModule,
		MatProgressBarModule,
		MatCardModule,
		MatButtonModule,
		MatInputModule,
		MatExpansionModule,
		MatDialogModule,
		MatMenuModule,
		MatSidenavModule,
		MatListModule,
		MatSlideToggleModule,
		MatRadioModule,
		MatStepperModule,
		MatGridListModule,
		MatProgressSpinnerModule,
		MatToolbarModule,
		AutoCompleteModule,
		ButtonModule,
		CheckboxModule,
		MultiSelectModule,
		RadioButtonModule,
		TableModule,
		CalendarModule,
		OverlayPanelModule,
		DropdownModule,
		SliderModule,
		ListboxModule
	],
	exports: [
		MatIconModule,
		MatTooltipModule,
		MatSelectModule,
		MatProgressBarModule,
		MatCardModule,
		MatButtonModule,
		MatInputModule,
		MatExpansionModule,
		MatDialogModule,
		MatMenuModule,
		MatSidenavModule,
		MatListModule,
		MatSlideToggleModule,
		MatRadioModule,
		MatStepperModule,
		MatGridListModule,
		MatProgressSpinnerModule,
		MatToolbarModule,
		AutoCompleteModule,
		ButtonModule,
		CheckboxModule,
		MultiSelectModule,
		RadioButtonModule,
		TableModule,
		CalendarModule,
		OverlayPanelModule,
		DropdownModule,
		SliderModule,
		ListboxModule
	]
})
export class MaterialAppModule { }
